//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { clientContractShiftApi, customerShiftApi, clientInvoiceShiftApi } from '@/api/enterprise';
export default {
  name: 'TransferDialog',
  components: {
    selectMember: function selectMember() {
      return import('@/components/form-common/select-member');
    }
  },
  props: {
    fromData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      userList: [],
      checkList: [],
      transfer: [{
        value: 1,
        label: this.$t('customer.customertransfer')
      }, {
        value: 2,
        label: this.$t('customer.contracttransfer')
      }, {
        value: 3,
        label: this.$t('customer.invoicetransfer')
      }],
      loading: false
    };
  },
  computed: {
    lang: function lang() {
      return this.$store.getters.lang;
    }
  },
  watch: {
    fromData: {
      handler: function handler(nVal) {
        this.checkList.push(nVal.type);
      },
      deep: true
    },
    lang: function lang() {
      this.setOptions();
    }
  },
  methods: {
    setOptions: function setOptions() {
      this.transfer = [{
        value: 1,
        label: this.$t('customer.customertransfer')
      }, {
        value: 2,
        label: this.$t('customer.contracttransfer')
      }, {
        value: 3,
        label: this.$t('customer.invoicetransfer')
      }];
    },
    handleClose: function handleClose() {
      this.userList = [];
      this.checkList = [];
      this.dialogVisible = false;
    },
    handleOpen: function handleOpen() {
      this.dialogVisible = true;
    },
    // 选择成员完成回调
    getSelectList: function getSelectList(data) {
      this.userList = data;
    },
    handleAdd: function handleAdd() {
      if (this.userList.length <= 0) {
        this.$message.error(this.$t('customer.placeholder25'));
      } else {
        var data = {
          to_uid: this.userList[0].value,
          data: this.fromData.ids
        };
        if (this.fromData.type === 1) {
          data.contract = this.checkList.includes(2) ? 1 : 0;
          data.invoice = this.checkList.includes(3) ? 1 : 0;
          this.clientDataShift(data);
        } else if (this.fromData.type === 2) {
          data.invoice = this.checkList.includes(3) ? 1 : 0;
          this.clientContractShift(data);
        } else if (this.fromData.type === 3) {
          this.clientInvoiceShift(data);
        }
      }
    },
    // 客户管理--批量转移
    clientDataShift: function clientDataShift(data) {
      var _this = this;
      this.loading = true;
      customerShiftApi(data).then(function (res) {
        _this.loading = false;
        _this.userList = [];
        _this.handleClose();
        _this.$emit('handleTransfer');
        _this.$refs.department.selectList = {};
      }).catch(function (error) {
        _this.loading = false;
      });
    },
    // 合同管理--批量转移
    clientContractShift: function clientContractShift(data) {
      var _this2 = this;
      this.loading = true;
      clientContractShiftApi(data).then(function (res) {
        _this2.loading = false;
        _this2.userList = [];
        _this2.handleClose();
        _this2.$emit('handleTransfer');
        _this2.$refs.department.selectList = {};
      }).catch(function (error) {
        _this2.loading = false;
      });
    },
    // 发票管理--批量转移
    clientInvoiceShift: function clientInvoiceShift(data) {
      var _this3 = this;
      this.loading = true;
      clientInvoiceShiftApi(data).then(function (res) {
        _this3.loading = false;
        _this3.userList = [];
        _this3.handleClose();
        _this3.$emit('handleTransfer');
        _this3.$refs.department.selectList = {};
      }).catch(function (error) {
        _this3.loading = false;
      });
    }
  }
};